/*
    © 2021 EcomGraduates.com
    https://www.ecomgraduates.com
*/

// Handle ajax 'Add To Cart' (ATC) forms
window.onSubmitAtcForm = async ($form, event) => {
    console.log('event', event)

    event.preventDefault()

    $form.classList.add('loading')

    await fetch('/cart/add.js', { method: 'POST', body: new FormData($form) })

    const upsellAddons = []

    $form.querySelectorAll('[data-atc-addon]:checked').forEach((checkbox) => {
        upsellAddons.push({
            id: Number(checkbox.value),
            quantity: 1
        })
    })

    if (upsellAddons.length) {
        await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                items: upsellAddons
            })
        })
    }

if ($form.getAttribute('id') === 'form-custom-house-portrait') {
    const dataBundle = $form.getAttribute('data-bundle');
    
    // Redirect if data-bundle doesn't exist OR if it exists and is set to "false"
    if (dataBundle === null || dataBundle === "true") {
        window.location.href = '/pages/bundle-and-save';
    } else {
        $form.classList.remove('loading');
        loadOffcanvasCart();
    }
} else {
    $form.classList.remove('loading');
    loadOffcanvasCart();
}
}

// Offcanvas cart - load it on ajax add/update
const loadOffcanvasCart = async () => {
    const offcanvasCart = document.querySelector('#offcanvas-cart')
    const bsOffcanvas = bootstrap.Offcanvas.getOrCreateInstance(offcanvasCart)
    const form = offcanvasCart.querySelector('form[action="/cart"]')
    const cartCountBadges = document.querySelectorAll('.cart-count-badge')

    form.classList.add('loading')

    if (!offcanvasCart.classList.contains('show')) {
        bsOffcanvas.show()
    }

    const respoonse = await fetch(window.location.href)
    const data = await respoonse.text()

    const parser = new DOMParser()
    const newDocument = parser.parseFromString(data, 'text/html')

    form.replaceWith(newDocument.querySelector('#offcanvas-cart form[action="/cart"]'))
    form.classList.remove('loading')

    cartCountBadges.forEach((badge) => {
        badge.style.display = 'block'
        badge.textContent = newDocument.querySelector('.cart-count-badge').textContent
    })

    initQuantityInputs()
    initRemoveButtons()
    initNoteInput()
    initDiscountInput()
    initCheckoutButton()
    initCartUpsellsAjaxATC()
    initCartGoal()

    if (!document.querySelector('#offcanvas-cart .product-list')) {
        cartCountBadges.forEach((badge) => {
            badge.style.display = 'none'
        })
        setTimeout(() => {
            bsOffcanvas.hide()
        }, 500)
    }
}

// Cart Note
const initNoteInput = () => {
    document.querySelectorAll('.btn-apply-note').forEach((btn) => {
        btn.addEventListener('click', async (e) => {
            btn.innerHTML = `
                <div 
                    class="spinner-border spinner-border-sm" 
                    role="status"
                    style="width: 1rem; height: 1rem">
                    <span class="visually-hidden">Loading...</span>
                </div>
            `
            const note = btn.previousElementSibling.value
            console.log(note)

            const response = await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    note: note
                })
            })
            const data = await response.json()
            console.log(data)

            btn.innerHTML = '✓'

            setTimeout(() => {
                btn.innerHTML = btn.dataset.text
            }, 2000)
        })
    })
}
initNoteInput()

// Discount box
const initDiscountInput = () => {
    document.querySelectorAll('.btn-apply-discount').forEach((btn) => {
        btn.addEventListener('click', (e) => {
            btn.innerHTML = `
                <div 
                    class="spinner-border spinner-border-sm mx-2" 
                    role="status"
                    style="width: 1rem; height: 1rem">
                    <span class="visually-hidden">Loading...</span>
                </div>
            `
        })
    })
}
initDiscountInput()

// Quantity inputs
const initQuantityInputs = () => {
    document.querySelectorAll('input[name="updates[]"]').forEach((input) => {
        input.addEventListener('change', async (e) => {
            await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id: input.dataset.lineItemKey,
                    quantity: input.value
                })
            })
            if (document.body.classList.contains('request-page-type-cart')) {
                window.location.reload()
            } else {
                loadOffcanvasCart()
            }
        })
    })
}
initQuantityInputs()

// Remove buttons
const initRemoveButtons = () => {
    document.querySelectorAll('.btn-remove-line-item').forEach((btn) => {
        btn.addEventListener('click', async (e) => {
            await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id: btn.dataset.lineItemKey,
                    quantity: 0
                })
            })
            loadOffcanvasCart()
        })
    })
}
initRemoveButtons()

// Checkout button - Indicate loading on click
const initCheckoutButton = () => {
    document.querySelectorAll('form[action="/cart"] .btn-checkout')
        .forEach((btn) => {
            btn.addEventListener('click', (e) => {
                btn.style.height = btn.clientHeight + 'px'
                btn.innerHTML = `
                    <div 
                        class="spinner-border spinner-border-sm" 
                        role="status"
                        style="width: 1.4rem; height: 1.4rem">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                `
            })
        })
}
initCheckoutButton()

// Cart upsells - handle ajax ATC
const initCartUpsellsAjaxATC = () => {
    document.querySelectorAll('#offcanvas-cart-upsells-list .btn-atc')
        .forEach((btn) => {
            btn.addEventListener('click', async (e) => {
                btn.style.height = btn.clientHeight + 'px'
                btn.innerHTML = `
                    <div 
                        class="spinner-border spinner-border-sm" 
                        role="status"
                        style="width: 1rem; height: 1rem">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                `
                const variantId = btn.closest('.product-item').querySelector('[name="id"]').value

                await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        items: [{
                            id: Number(variantId),
                            quantity: 1
                        }]
                    })
                })
                loadOffcanvasCart()
            })
        })
}
initCartUpsellsAjaxATC()

// Cart Goal - Animate width
const initCartGoal = () => {
    const progressBar = document.querySelector('#cart-goal .progress-bar')
    if (progressBar) {
        setTimeout(() => {
            progressBar.style.width = progressBar.dataset.width
        }, 250)
    }
}
initCartGoal()

// Offcanvas cart - Open it if URL contains '#cart'
if (window.location.hash.includes('#cart')) {
    const offcanvasCart = bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-cart')
    offcanvasCart.show()
}
